import React, { useState, useEffect } from 'react';
import { Checkbox, TextField, FormControlLabel } from '@mui/material';
// don't import submitFormData here; parent will handle submission via onFormSubmit

const PropertyEquipmentDamagesForm = ({ incidentId, initialData = {}, onSaved, onFormSubmit, onFormChange }) => {
  const [form, setForm] = useState({
    equipmentInvolved: initialData.equipmentInvolved || 'No',
    equipmentOther: initialData.equipmentOther || '',
    propertyInvolved: initialData.propertyInvolved || 'No',
    propertyDescription: initialData.propertyDescription || '',
    over5000: initialData.over5000 || 'No',
    reportedToPolice: initialData.reportedToPolice || 'No',
    policeReportDate: initialData.policeReportDate || '',
    under5000: initialData.under5000 || 'No',
    estimatedDamages: initialData.estimatedDamages || ''
  });

  const handleChange = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

  // Call onFormChange when local form changes so parent can store it for later submission
  useEffect(() => {
    if (typeof onFormChange === 'function') {
      try { onFormChange(form); } catch (e) { console.error('onFormChange failed', e); }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  // If an explicit onFormSubmit is provided and an incidentId exists, optionally submit.
  // We intentionally do not submit automatically here by default to avoid surprises.

  return (
    <div style={{ padding: 12 }}>
      <h4>Property/Equipment Damages</h4>
      <div>
        <FormControlLabel
          control={<Checkbox checked={form.equipmentInvolved === 'Yes'} onChange={(e) => handleChange('equipmentInvolved', e.target.checked ? 'Yes' : 'No')} />}
          label="Equipment involved"
        />
        {form.equipmentInvolved === 'Yes' && (
          <TextField label="Other (describe equipment)" value={form.equipmentOther} onChange={(e) => handleChange('equipmentOther', e.target.value)} fullWidth margin="normal" />
        )}
      </div>

      <div>
        <FormControlLabel
          control={<Checkbox checked={form.propertyInvolved === 'Yes'} onChange={(e) => handleChange('propertyInvolved', e.target.checked ? 'Yes' : 'No')} />}
          label="Property involved"
        />
        {form.propertyInvolved === 'Yes' && (
          <TextField label="Describe property damage" value={form.propertyDescription} onChange={(e) => handleChange('propertyDescription', e.target.value)} fullWidth margin="normal" />
        )}
      </div>

      <div>
        <FormControlLabel
          control={<Checkbox checked={form.over5000 === 'Yes'} onChange={(e) => {
            const val = e.target.checked ? 'Yes' : 'No';
            // enforce mutual exclusivity
            setForm(prev => ({ ...prev, over5000: val, under5000: val === 'Yes' ? 'No' : prev.under5000 }));
          }} />}
          label="Over $5,000.00 estimated damages?"
        />
        {form.over5000 === 'Yes' && (
          <div>
            <FormControlLabel
              control={<Checkbox checked={form.reportedToPolice === 'Yes'} onChange={(e) => setForm(prev => ({ ...prev, reportedToPolice: e.target.checked ? 'Yes' : 'No' }))} />}
              label="Reported to Police?"
            />
            {form.reportedToPolice === 'Yes' && (
              <TextField label="Date reported to police" type="date" value={form.policeReportDate} onChange={(e) => setForm(prev => ({ ...prev, policeReportDate: e.target.value }))} fullWidth margin="normal" InputLabelProps={{ shrink: true }} />
            )}
          </div>
        )}
      </div>

      <div>
        <FormControlLabel
          control={<Checkbox checked={form.under5000 === 'Yes'} onChange={(e) => {
            const val = e.target.checked ? 'Yes' : 'No';
            setForm(prev => ({ ...prev, under5000: val, over5000: val === 'Yes' ? 'No' : prev.over5000 }));
          }} />}
          label="Under $5,000.00 estimated damages?"
        />
        {form.under5000 === 'Yes' && (
          <TextField label="Estimated damages" value={form.estimatedDamages} onChange={(e) => setForm(prev => ({ ...prev, estimatedDamages: e.target.value }))} fullWidth margin="normal" />
        )}
      </div>
    </div>
  );
};

export default PropertyEquipmentDamagesForm;
